export default {
  install (Vue, opts) {
    Vue.mixin({
      methods: {
        setPageMeta ({ pageTitle }) {
          const titleElement = document.getElementsByTagName('title')[0]
          const title = `Shopping List: ${pageTitle}`
          if (titleElement) {
            titleElement.innerHTML = title
          } else {
            document.title = title
          }
        }
      }
    })
  }
}
